"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterComponentProps = void 0;
const table_columns_1 = require("../../table-columns");
const attributes_1 = require("../../../constants/attributes");
exports.filterComponentProps = {
    enableFilterClear: (field) => {
        if (attributes_1.DATE_COLUMNS.includes(field)) {
            return true;
        }
        const { dataMeta: { isMeasure }, } = (0, table_columns_1.parseColumnId)(field);
        return !!isMeasure;
    },
};
